import React from 'react';

import {Group} from 'lib/api/backend.schemas';

import {palette} from 'styles/mui/scss';

import {Box, Typography} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';

import styles from './GroupIcons.module.scss';

export const GroupIcons = ({group}: {group: Group}) => {
  return (
    <Box className={styles.iconsBox}>
      <Box className={styles.iconsWrapper}>
        {group?.cargoLoad ? (
          <>
            <CustomIcon
              name="drivingLicense"
              className={styles.icon}
              style={{marginRight: '2px'}}
            />
            <Typography>{group?.licenseClass}</Typography>
          </>
        ) : (
          <>
            <CustomIcon name="door" className={styles.icon} style={{marginRight: '2px'}} />
            <Typography component="span">{group?.numberDoors}</Typography>
          </>
        )}
      </Box>
      <Box sx={{display: 'flex', color: palette.colorGrey80, alignItems: 'center'}}>
        {group?.cargoLoad ? (
          <>
            <CustomIcon name="weight" className={styles.icon} style={{marginRight: '2px'}} />
            <Typography>{group?.cargoLoad}</Typography>
          </>
        ) : (
          <>
            <CustomIcon name="people" className={styles.icon} style={{marginRight: '2px'}} />
            <Typography component="span">{group?.numberSeats}</Typography>
          </>
        )}
      </Box>
    </Box>
  );
};
